export default "__VITE_ASSET__094a3fbb__"